export default {
  UTMNAD83Zone17N: 1, 
  UpperCanadaGeoGrid: 2,
  UpperBeaverGeologyGrid: 3,
  UTMNAD83Zone14: 4, 
  UTMNAD83Zone15: 5, 
  Unknown : 99
};